export class UserFacingError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'UserFacingError';
  }
}

export function friendlyStorageError(error: unknown): string {
  if (error instanceof DOMException && error.name === 'QuotaExceededError') {
    return 'На устройстве закончилось место. Уже сохранённые данные не изменены. Освободите место и повторите.';
  }
  if (error instanceof Error) return error.message;
  return 'Не удалось сохранить данные. Уже сохранённые записи не изменены.';
}
